'use strict';

var validMoment = require('../helpers/is-valid-moment-object');

module.exports = function (value, dateFormat) {

  if (!validMoment(value)) return value;

  return value.format(dateFormat);
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/filters/format-date.js